var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPickupBlue = function SvgPickupBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_828",
    "data-name": "Group 828",
    width: 72.997,
    height: 34.714,
    viewBox: "0 0 72.997 34.714",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820",
    transform: "translate(15.825 11.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1074",
    "data-name": "Rectangle 1074",
    width: 10.218,
    height: 2.157,
    fill: "#06016c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    transform: "translate(4.769 11.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1075",
    "data-name": "Rectangle 1075",
    width: 10.218,
    height: 2.157,
    fill: "#06016c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822",
    transform: "translate(53.765 21.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M900.414,624.2a6.371,6.371,0,0,0-.532-.419,6.6,6.6,0,0,0-7.058,0,6.949,6.949,0,0,0-2.914,5.38,6.105,6.105,0,0,0,.062.616c.013.141.021.282.042.419s.043.281.076.419a6.426,6.426,0,0,0,12.527,0c.032-.138.053-.279.076-.419s.029-.279.042-.419a6.087,6.087,0,0,0,.062-.616A6.4,6.4,0,0,0,900.414,624.2Zm.06,5.577a3.732,3.732,0,0,1-.083.419,3.873,3.873,0,0,1-.13.419,4.163,4.163,0,0,1-7.817,0,4.1,4.1,0,0,1-.13-.419c-.035-.138-.061-.276-.083-.419a4.176,4.176,0,1,1,8.3-.616A4.008,4.008,0,0,1,900.474,629.779Z",
    transform: "translate(-889.909 -622.719)",
    fill: "#06016c"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M911.633,622.626a.418.418,0,1,1,0-.837h4.312a8.346,8.346,0,0,0-5.541-2.68l-6.314-.471a4.444,4.444,0,0,1-2.964-1.446l-4.479-4.931a23.608,23.608,0,0,0-17.438-7.718h-2.2a2.143,2.143,0,0,0-2.14,2.14v10.271a2.146,2.146,0,0,1-2.143,2.143H847.654a2.306,2.306,0,0,0-2.306,2.2l-.089,2.384h2.295a.419.419,0,1,1,0,.837h-2.326l-.092,2.492H856a7.227,7.227,0,0,1,8.768,0h36.193a7.23,7.23,0,0,1,8.771,0h8.4a8.339,8.339,0,0,0-1.515-4.388Zm-29.639.125h-2.171a.419.419,0,1,1,0-.837h2.171a.419.419,0,0,1,0,.837Zm17.318-4.378a1.211,1.211,0,0,1-1.11.717l-18.96.085h-.011a1.857,1.857,0,0,1-1.858-1.859v-10.29a.861.861,0,0,1,.861-.86h1.6a21.521,21.521,0,0,1,16.263,7.419l3.018,3.48A1.209,1.209,0,0,1,899.313,618.373Z",
    transform: "translate(-845.136 -604.544)",
    fill: "#06016c"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(0.025 23.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M855.064,623.954h-9.907a5.985,5.985,0,0,0,5.956,5.577h2.015c-.018-.2-.031-.408-.031-.616A7.243,7.243,0,0,1,855.064,623.954Z",
    transform: "translate(-845.157 -623.954)",
    fill: "#06016c"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(8.802 21.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M862.97,624.2a6.341,6.341,0,0,0-.531-.419,6.458,6.458,0,0,0-.771-.419,6.222,6.222,0,0,0-5.517,0,6.463,6.463,0,0,0-.771.419,6.949,6.949,0,0,0-2.914,5.38c0,.211.043.411.063.616.014.141.02.282.042.419s.043.281.076.419a6.426,6.426,0,0,0,12.527,0c.031-.138.052-.279.075-.419s.029-.279.043-.419c.019-.205.062-.4.062-.616A6.4,6.4,0,0,0,862.97,624.2Zm.061,5.577c-.022.143-.048.281-.083.419a4.168,4.168,0,0,1-8.077,0c-.035-.138-.061-.276-.083-.419a4.185,4.185,0,1,1,8.242,0Z",
    transform: "translate(-852.466 -622.719)",
    fill: "#06016c"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826",
    transform: "translate(20.559 23.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M896.591,623.954H862.257a7.243,7.243,0,0,1,1.967,4.961c0,.208-.014.413-.031.616h30.464c-.018-.2-.031-.408-.031-.616A7.247,7.247,0,0,1,896.591,623.954Z",
    transform: "translate(-862.257 -623.954)",
    fill: "#06016c"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827",
    transform: "translate(65.523 23.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M901.668,628.915c0,.186-.014.37-.029.554a6.254,6.254,0,0,0,3.846-1.826,5.913,5.913,0,0,0,1.658-3.688H899.7A7.243,7.243,0,0,1,901.668,628.915Z",
    transform: "translate(-899.701 -623.954)",
    fill: "#06016c"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPickupBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pickupBlue.9a0cf5f3.svg";
export { ForwardRef as ReactComponent };